//var ScrollMagic = require('scrollmagic');

var Common = {};

//--------------
// Variables
//--------------

//--------------
// Functions
//--------------

/**
 * Init common scripts
 * @return {[type]} [description]
 */
Common.init = function(){
	var Header = require('../modules/header.js');

	// Hide console on production mode
	if(App.mode == 'production'){
	  console.log = function(){};
	  console.info = function(){};
	  console.warn = function(){};
	  console.error = function(){};

	  // Analytics
	  var pagePath = (window.location.href).replace(window.location.origin, '').toLowerCase();
	 	gtag('js', new Date());
	  gtag('config', 'UA-132206738-1', {
      'anonymize_ip': true, // for GDPR
      'page_title' : document.title,
      'page_path': pagePath
    });
	}
	
	//-- jQuery validate
	$('.js-form-validate').validate();

	//-- Init lazy load
	Observer.observe();
	//const trigger = document.querySelector('.js-home-banner-image')
	//App.Observer.triggerLoad(trigger);
	
	//-- SCROLLBAR
	if(Scrollbar){
		Scrollbar.destroy();
	}

	Scrollbar = SmoothScroll.init(document.querySelector('.js-scroll-content'));

	if($('html').hasClass('touchevents')){
		$('.js-scroll-content').css('overflow', 'auto');
		$('.js-scroll-content').css('min-height', 'auto');
		$('.js-scroll-content').css('height', 'auto');
	}

	//-- Animations
	if(App.animationsController){
		App.animationsController.destroy();
	}
  
  App.animationsController = new ScrollMagic.Controller();
	Animations.init();

	//-- Anchor animation
	$('.js-anchor').click(function() {
    	//-- Get anchor
		var href = $(this).attr('href');
		if (typeof href == 'undefined') {
		    href = $(this).data('href');
		}

		//-- Get target block
		var scrollTop = $(href).offset().top + Scrollbar.offset.y;

		//-- Scroll spped
		var speed = 1500;
		if (typeof $(this).data('speed') !== 'undefined') {
			speed = $(this).data('speed');
		}

		if($('html').hasClass('touchevents')){
			$('html, body').animate({
				scrollTop: scrollTop - 80
			}, speed - 500);
		} else { 
			Scrollbar.scrollTo(0, scrollTop - 80, speed);
		}

		return false;
	});

	//-- 
	var links = document.querySelectorAll('a[href]');
	var cbk = function(e) {
	 if(e.currentTarget.href === window.location.href) {
	 	 Header.closeMenu();
	   e.preventDefault();
	   //e.stopPropagation();
	 }
	};

	for(var i = 0; i < links.length; i++) {
	  links[i].addEventListener('click', cbk);
	}

	$(window).on('resize', function() {
		if($(window).width() < 768){
			$('iframe[title="chat widget"]').css({
				'opacity': 0,
				'pointer-events': 'none'
			});
		} else {
			$('iframe[title="chat widget"]').css({
				'opacity': 1,
				'pointer-events': 'auto'
			});
		}
	});

}

/**
 * Destroy common scripts
 * @return {void}
 */
Common.destroy = function(){

}

//--------------
// Execution
//--------------

module.exports = Common;